import React, {ReactElement, ReactNode} from 'react'
import PopoverComponent from "@ui/popover/PopoverComponent";
import {ChildrenPopoverCb, ClosePopoverFeaturesProps, ClosePopoverFn} from "@ui/popover/types";

interface IProps {
    component?: ReactElement,
    children?: ReactNode | ChildrenPopoverCb,
    closeMenuFn?: () => void,
    button: ReactElement,
    anchorPosition?: {
        top: number;
        left: number;
    },
    anchorOrigin?: {
        vertical: 'top' | 'center' | 'bottom' | number;
        horizontal: 'left' | 'center' | 'right' | number;
    },
    hasCloseBtn?:boolean
    onOpenChange?: (open: boolean) => void
}

const PopoverCustom = React.forwardRef(({
                                            component,
                                            children,
                                            closeMenuFn,
                                            button,
                                            anchorOrigin,
                                            anchorPosition,
                                            hasCloseBtn,
                                            onOpenChange,
                                        }: IProps, ref) => {

    const popoverRef = React.useRef(null);

    React.useImperativeHandle(ref, () => ({
        closePopover(props: ClosePopoverFeaturesProps) {
            if (popoverRef) {
                popoverRef.current.closePopover(props);
            }
        },

    }), [popoverRef]);

    const closePopoverFn: ClosePopoverFn = ({confirm = true, confirmMessage, callback} = {confirm: true}) => {
        if (popoverRef.current.closePopover) {
            popoverRef.current.closePopover({confirm, confirmMessage, callback});
        }
    };


    return (
        <PopoverComponent
            ref={popoverRef}
            button={button}
            anchorOrigin={anchorOrigin}
            anchorPosition={anchorPosition}
            hasCloseBtn={hasCloseBtn}
            onOpenChange={onOpenChange}
        >

            {component ? React.cloneElement(component, {
                    closePopoverFn,
                    closeMenuFn,
                })
                :  typeof children === 'function' ? children({closePopoverFn}) : children
            }
        </PopoverComponent>

    );
})

export default PopoverCustom;